// Tyler.API.Common.Interfaces.InfoTableActionType
export enum InfoTableActionType {
    Client = 0,
    Intent = 1,
    Server = 2,
    Metadata = 3
}
